import React from 'react'
import { Tag } from 'antd'
import { InputAdd } from './InputAdd'
import styles from './MultiInput.module.scss'

interface Props {
  disabled?: boolean
  value?: string[]
  placeholder?: string
  validate?: (value: string) => boolean
  onChange?: (value: string[]) => void
}

export const MultiInput = ({ disabled, value = [], placeholder, validate, onChange = () => {} }: Props) => {
  const removeValue = React.useCallback((v: string) => {
    !disabled && onChange(value?.filter(i => i !== v))
  }, [value, disabled, onChange])

  return (
    <div className={styles.root}>
      <InputAdd
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        validate={validate}
        onChange={onChange}
      />

      {value?.map(value => (
        <Tag
          closable={!disabled}
          key={value}
          onClose={() => removeValue(value)}
          className={styles.tag}
        >{value}</Tag>
      ))}
    </div>
  )
}
